/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementGenerateZipImageResponse } from './EventManagementGenerateZipImageResponse';

export type EventManagementGenerateZipImageResponseApiRespoonse = {
    data?: EventManagementGenerateZipImageResponse;
    status?: EventManagementGenerateZipImageResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementGenerateZipImageResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

